import  useNavigation from '../../../hooks/useNavigation.js'

export const ticketsColumns = (userData) => {
  const { navigateTo } = useNavigation();
  const columns = 
 [
    {
      name: 'Ticket Code',
      cell: row => <div className="custom-cell-order_Code"><a href="javascript:void(0)" onClick={() =>  navigateTo('viewTicket','ticket-details',row.id)}>{row.ticket_code}</a></div>,
      sortable: true,
     
    },
    {
        name: 'Order Code',
        cell: row => <div className="custom-cell-order_Code"><a href="javascript:void(0)" onClick={() =>  navigateTo('viewTransaction','transaction',row.transaction_id) }>{row.order_code}</a></div>,
        sortable: true,
       
      },
   
    {
      name: 'Category',
      selector: row => <>
      <div >
      {row.category}
      </div>
      </>,
      sortable: true,
    },
    {
      name: 'Date',
      selector: row =>  <div className="custom-cell-order_Code">{row.created_on}</div>,
      sortable: true,
    },
    {
      name: 'Status',
      selector: row => 
      <>
      {row.status}

      </>,
      
      sortable: true,
    },
    {
      name: 'Priority',
      selector: row => 
      <>
      {row.priority}

      </>,
      
      sortable: true,
    },
    {
      name: 'Actions',
      selector: row => <>

      <div  style={{display:'flex'}}>
      
        <a className="fview tooltip" style={{'cursor':'pointer'}} onClick={() => navigateTo('viewTicket','ticket-details',row.id)}>
          <i className="fa fa-eye" />
          <span className="tooltiptext"  >View</span>
        </a>
        
        </div>
      </>
    },
  ]
  let userRole;
  if(userData && userData.user && userData.user.data) {
    userRole = userData.user.data.role.role_code
 }
 if(userRole == 'ADMIN') {
   const cols = [
     ...columns.slice(0, 4), // Keep the first 4 columns unchanged
     // Add new columns here
    
     ...[{
       name: 'Merchant',
       cell: row => <div className="custom-cell-order_Code">{row.merchant_name || '-'}</div>,
       sortable: true,
      
     },{
       name: 'Distributor',
       cell: row => <div className="custom-cell-order_Code">{row.distributor_name || '-'}</div>,
       sortable: true,
      
     },
     {
       name: 'Agent',
       cell: row => <div className="custom-cell-order_Code">{row.agent_name || '-'}</div>,
       sortable: true,
      
     },
     {
       name: 'Agent Code',
       cell: row => (
         <div className="custom-cell-order_Code">
           {row.agent_code && row.agent_code.trim() !== '-' ? (
             <a href="javascript:void(0)" onClick={() => viewAgent(row)}>{row.agent_code}</a>
           ) : (
             '-'
           )}
         </div>
       ),
       sortable: true,
      
     }], 
     ...columns.slice(4), 
   ];
   return cols
}
if(userRole == 'DADMIN') {
    const updatedColumns = [
      ...columns.slice(0, 4), // Keep the first 4 columns unchanged
      // Add new columns here
     
      ...[{
        name: 'Merchant',
        cell: row => <div className="custom-cell-order_Code">{row.merchant_name || '-'}</div>,
        sortable: true,
       
      }], 
      ...columns.slice(4), 
    ];
    return updatedColumns
}

  return columns
}

